export * from './pmap.component';